import React from 'react';

const SelectBranch = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M19.4234 4.57684C15.33 0.483503 8.66835 0.483503 4.57502 4.57684C0.480853 8.671 0.480853 15.3318 4.57502 19.426C6.62169 21.4727 9.31085 22.4968 11.9992 22.4968C14.6875 22.4968 17.3767 21.4735 19.4234 19.426C23.5175 15.3318 23.5175 8.671 19.4234 4.57684ZM17.8325 17.8352C14.6159 21.0518 9.38169 21.0518 6.16502 17.8352C2.94835 14.6185 2.94835 9.38434 6.16502 6.16767C7.77335 4.55934 9.88585 3.75517 11.9984 3.75517C14.1109 3.75517 16.2234 4.55934 17.8317 6.16767C21.0484 9.38434 21.0484 14.6185 17.8317 17.8352H17.8325Z'
        fill='#200000'
      />
      <path
        d='M13.125 10.875V6L10.875 6.75V10.875H6V13.125H10.875V18L13.125 17.25V13.125H18V10.875H13.125Z'
        fill='#200000'
      />
    </svg>
  );
};

export default SelectBranch;
